exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categorySelect__ads___qigQV {\n  margin: 0 -15px;\n  min-height: 0; }\n  .categorySelect__ads___qigQV iframe {\n    margin-top: 15px;\n    margin-bottom: 0; }\n", ""]);

// exports
exports.locals = {
	"ads": "categorySelect__ads___qigQV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdFormPage/SelectingCategory/CategorySelect/categorySelect.scss
// module id = 4725
// module chunks = 6